import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  subtitle = 'From parkour coaches running gym programs, after-school clubs, PE classes and holiday camps.',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-navy' : 'bg-navy-deep';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-213" data-mp="2x0jngkbrvvde">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-214" data-mp="2x2w2aom8hpm8">
        <div className="text-center" data-id="element-215" data-mp="2s2rvjqb4o997">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-216" data-mp="2s3tai5v9lfw7">
            Coach to coach
          </p>
          <h2 className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-217" data-mp="qalko2i0zfw2">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-218" data-mp="h4wyecfigumy">{subtitle}</p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-219" data-mp="m62mty251vqo">
          {testimonials.map((item, i) => <figure key={i} className="flex flex-col rounded-2xl border border-navy-line bg-navy-card p-5 shadow-card" data-id="element-220" data-mp="79bo7r0ago24" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-221" data-mp="c8y3s73lage3">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/50" data-id="element-222" data-mp="zyiwvitgiu13" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy-mid text-[13px] font-bold text-white ring-1 ring-navy-line" aria-hidden="true" data-id="element-223" data-mp="1ivk3t96kn47o">
                    {initials(item.author)}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-224" data-mp="1sio36x9x32zr">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-225" data-mp="1ofrf4r1lyeof" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-ink" data-id="element-226" data-mp="1ejemlwhsu6v9">“{item.quote}”</blockquote>
              <figcaption className="mt-auto pt-4 text-xs text-ink-soft" data-id="element-227" data-mp="19s6agsp347ee">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-228" data-mp="14t24sc1dcrst">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(/\s+/).map(part => part.replace(/[^A-Za-z]/g, '').charAt(0)).join('').slice(0, 2).toUpperCase() || 'PK';
}